import * as React from "react";
const B2Fill = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.1745 7.76298V13.6259H20.0742C19.9242 13.6134 19.5991 13.4259 19.5241 13.2883L18.224 10.8257C17.7115 9.85062 16.824 9.30058 15.8739 9.35058C14.9238 9.40059 14.1113 10.0381 13.6987 11.0757L11.9736 15.401L11.7236 14.7509C11.1111 13.1633 9.36096 11.9633 7.63584 11.9633L0.172852 12.0008V7.76298C0.172852 3.21268 2.88553 0.5 7.43583 0.5H17.9115C22.4618 0.5 25.1745 3.21268 25.1745 7.76298Z"
      fill="#276AA6"
    />
    <path
      d="M25.1745 18.237V15.4994H20.0742C19.2366 15.4994 18.249 14.8993 17.8615 14.1618L16.5614 11.6991C16.2114 11.0366 15.7114 11.0741 15.4364 11.7616L12.5612 19.0246C12.2486 19.8372 11.7236 19.8372 11.3986 19.0246L9.9735 15.4244C9.63598 14.5493 8.58591 13.8368 7.64834 13.8368L0.172852 13.8743V18.237C0.172852 22.7123 2.79802 25.4125 7.21082 25.4875C7.34833 25.5 7.49833 25.5 7.63584 25.5H17.6365C17.824 25.5 18.0115 25.5 18.1865 25.4875C22.5743 25.3875 25.1745 22.6998 25.1745 18.237Z"
      fill="#276AA6"
    />
  </svg>
);
export default B2Fill;
